import React from "react";
import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Seo } from "../components/Seo";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="max-w-[820px] mx-auto px-6 lg:px-10 py-24">
      <Seo title="Checkout Cancelled" description="Your Peptide Labs N.I. checkout was cancelled." noindex />
      <div className="border border-[#2A2A2A] rounded-3xl bg-[#0e0e0e] p-12 text-center">
        <div className="w-14 h-14 mx-auto rounded-full bg-[#171717] border border-[#2A2A2A] grid place-items-center text-[#6E7784]">
          <XCircle size={28} />
        </div>
        <h1 className="mt-8 text-3xl lg:text-4xl text-white tracking-tight font-medium">
          Checkout cancelled.
        </h1>
        <p className="mt-4 text-[#B7BCC7]">
          Your cart is still saved. You can resume checkout whenever you're ready.
        </p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/cart" className="btn-primary inline-flex items-center gap-2">
            <ArrowLeft size={16} /> Return to Cart
          </Link>
          <Link to="/products" className="btn-ghost">Browse Products</Link>
        </div>
      </div>
    </div>
  );
}
